import FileCheckSelector from './FileCheckSelector.component';

export default FileCheckSelector;
